import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subGrid mtop-03" }
const _hoisted_4 = { style: {"grid-column":"left"} }
const _hoisted_5 = { style: {"grid-column":"middle"} }
const _hoisted_6 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_7 = {
  style: {"display":"flex","gap":"0.5rem"},
  class: "mtop-10"
}
const _hoisted_8 = {
  class: "bg-blue-04 pad-m rnd-m",
  style: {"display":"flex","flex-direction":"column","place-content":"space-between"}
}
const _hoisted_9 = { class: "mtop-20" }
const _hoisted_10 = { class: "row" }

import { ref, computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { apiCurrency, apiAmountCurrency} from '@/api/apicommon';
import officeapi from '@/api/officeapi';
import { FinancialChannelLightResponse } from '@/apiGenerate/medserver';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'doTransaction',
  props: {
  selectedInvoices: {
    type: Array,
    required: true,
  },
  targetFinancialChannel: {
    type: Object as PropType<FinancialChannelLightResponse>,
    required: true,
  },
  sourceFinancialChannel: {
    type: Object as PropType<FinancialChannelLightResponse>,
    required: true,
  },
  financialGroupId: {
    type: Number,
    required: true,
  },
},
  emits: ['reload'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props

const emits = __emit

const selectedInvoicesAmount = computed(() => {
  if (!props.selectedInvoices.length)  return "0";
  let newSum = 0
  props.selectedInvoices.forEach(invoice => {
    newSum += parseFloat(invoice.partial)
  })
  return newSum.toFixed(2) + " " + apiCurrency(props.selectedInvoices[0].currencyIso)
})

const currTransactionDate = ref(new Date().toISOString());

async function addTransactionsTo() {
  const sourceFinancialChannelId: string = (!props.sourceFinancialChannel.id || props.sourceFinancialChannel.type === 'RemainingBalance') ? null : props.sourceFinancialChannel.id.toString();

  const invoicesToMove = props.selectedInvoices
  const transactionDate = currTransactionDate.value;
  await Promise.all(
    invoicesToMove
      .filter(invoice => invoice.invoiceStatus !== "Precomplete")
      .map(async (invoice) => {
        const invoiceId = invoice.id
        const partial = invoice.partial
        return officeapi.addTransaction(sourceFinancialChannelId, props.targetFinancialChannel.id.toString(), invoiceId, transactionDate, partial);
      })
  )
  emits("reload");
}

function updateActDate(newIso: string) {
  currTransactionDate.value = newIso
}

function getPersonName(invoice: any) {
  const pwr = invoice.pwrCounterParty;
  return PersonService.formatName(pwr.lastName, pwr.firstName);
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal",
    style: {"display":"flex","flex-direction":"column","gap":"0.5rem","width":"fit-content"},
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_item, {
          txt: __props.selectedInvoices.length.toString(),
          styles: "font-l"
        }, null, 8, ["txt"]),
        _createVNode(_component_text_item, {
          txt: "Transaction(s)",
          styles: "font-l",
          class: "mleft-04"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedInvoices, (invoice, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_text_item, {
                txt: getPersonName(invoice),
                styles: "main-m"
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_text_item, {
                txt: invoice.invoiceReference,
                styles: "main-m"
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_text_item, {
                txt: _unref(apiAmountCurrency)(invoice.partial, invoice.currencyIso),
                class: "mleft-auto",
                styles: "main-h"
              }, null, 8, ["txt"])
            ])
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_text_item, {
          txt: "Date",
          styles: "font-mBold"
        }),
        _createVNode(_component_inputNewDate, {
          dateIso: currTransactionDate.value,
          calendar: false,
          trash: false,
          onChanged: updateActDate
        }, null, 8, ["dateIso"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_button_group, {
            styles: "border-h pad-s",
            style: {"padding-left":"0.6rem","padding-right":"0.6rem"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addTransactionsTo()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_text_item, {
                  txt: __props.targetFinancialChannel.title,
                  styles: "font-mBold"
                }, null, 8, ["txt"]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_text_item, {
                    txt: "Confirmer",
                    styles: "font-m"
                  }),
                  _createVNode(_component_text_item, {
                    txt: selectedInvoicesAmount.value,
                    styles: "main-h",
                    class: "mleft-04"
                  }, null, 8, ["txt"])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})